const API_BASE = 'https://zx6cnm6tid.execute-api.us-east-1.amazonaws.com/DEV';

export const API_URLS = {
    DATA: `${API_BASE}/data/`,
    SUBMISSION: `${API_BASE}/submission`,
    UPLOAD: `${API_BASE}/psurls/`,
    SETTINGS: `${API_BASE}/settings/`,
};
